import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Modal,
  ThemeProvider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// import { makeStyles } from "@mui/material/styles";

import CheckIcon from "@mui/icons-material/Check";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { basicTheme } from "../../themes/customTheme";
import Backdrop from "@mui/material/Backdrop";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import SnackBars from "../reusableComponents/SnackBar";
import BasicTextfield from "../reusableComponents/BasicTextfield";
import CustomTextField from "../reusableComponents/CustomTextField";
import BasicDropDown from "../reusableComponents/BasicDropDown";
// import AutoCompleteMultiDropdown from "./AutoCompleteMultiDropdown";
import {
  getFromData,
  postFormData,
} from "../../features/formManagement/formManagementAPIs";
import BackDropLoader from "../reusableComponents/BackDropLoader";
import dayjs from "dayjs";
import {
  getProjectData,
  postProjectData,
} from "../../features/projects/projectsAPIs";
import AutoCompleteDropdown from "../reusableComponents/AutoCompleteDropDown";
import { getPartnerData } from "../../features/partner/partnerAPIs";

const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflow: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  paddingLeft: 5,
  paddingTop: 2,
};

// const useStyles = makeStyles(() => ({
//   closeBtnStyle: {
//     zoom: "2.2",
//     alignItems: "right",
//     color: "#444444",
//     cursor: "pointer",
//     "&:hover": { opacity: 0.7 },
//     maxHeight: "1rem",
//     maxWidth: "1rem",
//   },
//   textField: {
//     "& .MuiInputBase-input": {
//       border: "none", // Remove the border
//     },
//     "& .MuiInput-underline:before": {
//       border: "none", // Remove the underline
//     },
//     "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
//       border: "none", // Remove the underline on hover
//     },
//   },
// }));

const ButtonStyle = styled(Button)({
  backgroundColor: "#1e88e5",
  color: "white",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

const CancelButtonStyle = styled(Button)({
  backgroundColor: "white",
  color: "#1e88e5",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

export default function PublishFormModal({
  schema,
  openAddModal,
  handleClose = () => {},
  setProjectSnackBarMessage = () => {},
  setProjectSnackBarType = () => {},
  setReload = () => {},
  setOpenSuccessBox = () => {},
  setSuccessMessage = () => {},
  setOpenSuccessBoxType = () => {},
}) {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const [datasetName, setDatasetName] = useState("");
  // const [projectStatus, setProjectStatus] = useState("");
  const [formIds, setFormIds] = useState([]);
  const [formIdList, setFormIdList] = useState([]);
  const [addPartnerSnackBar, setAddPartnerSnackBar] = useState(false);
  const [addPartnerSnackBarMessage, setAddPartnerSnackBarMessage] =
    useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [projectList, setProjectList] = useState([{ id: "", name: "" }]);
  const [projects, setProjects] = useState(null);
  // const [startDate, setStartDate] = useState(dayjs(new Date()));
  // const [formattedStartDate, setFormattedStartDate] = useState(
  //   dayjs(new Date()).format("YYYY-MM-DD")
  // );
  // const [endDate, setEndDate] = useState(dayjs(new Date()));
  // const [formattedEndDate, setFormattedEndDate] = useState(
  //   dayjs(new Date()).format("YYYY-MM-DD")
  // );

  const basicError = {
    datasetName: "",
    // projectStatus: "",
    // projectForms: "",
    // formIds: [],
    project: "",
    // project: "",
  };
  const [snackBarType, setSnackBarType] = useState("success");
  const [errors, setErrors] = useState(basicError);

  // const projectStatusList = ["Active", "Inactive"];
  const [loading, setLoading] = useState(false);

  const [partnerNamesData, setPartnerNamesData] = useState([]);
  //   const [project, setFarmerPartner] = useState([]);
  const loggedInUser = JSON.parse(window.localStorage.getItem("loggedInUser"));
  const [partnerDataResponse, setPartnerDataResponse] = useState([]);

  const validateProjectFormData = () => {
    let projectNameError = "";
    let projectError = "";
    // if (projectName.trim() === "") {
    //   projectNameError = "Project Name can't be empty";
    // }

    if (projects === null) {
      projectError = "Project can't be empty";
    }

    setErrors({
      ...errors,
      datasetName: projectNameError,
      project: projectError,
    });
  };

  // const handleChangeProjectName = (value) => {
  //   value = value.trim(); // Trim leading and trailing spaces
  //   const ALPHA_NUMERIC_SPECIAL_REGEX =
  //       /^[a-zA-Z0-9][a-zA-Z0-9\s_\.]*$/; // Allow alphanumeric, space, underscore, and dot

  //   if (value === "") {
  //       setErrors({ ...errors, projectName: "Project Name can't be empty" });
  //       setDatasetName("");
  //   } else if (!ALPHA_NUMERIC_SPECIAL_REGEX.test(value)) {
  //       setErrors({ ...errors, projectName: "Project Name can only start with alphanumeric characters and can contain spaces, underscores, and dots." });
  //       setDatasetName("");
  //     } else {
  //       setErrors({ ...errors, projectName: "" });
  //       setDatasetName(value);
  //   }
  // };

  const handleChangeProjectName = (value) => {
    // value = value.trim(); // Trim leading and trailing spaces

    if (value === "") {
      setErrors({ ...errors, datasetName: "Dataset Name can't be empty" });
    } else {
      setErrors({ ...errors, datasetName: "" });
    }
    setDatasetName(value);
  };

  // const handleChangeProjectStatus = (event) => {
  //   setProjectStatus(event.target.value);
  //   setErrors({ ...errors, projectStatus: "" });
  // };

  const handleChangeProjectFrom = (value) => {
    setFormIds(value);
    setErrors({ ...errors, projectForms: "" });
  };

  //   const handleChangeFarmerPartner = (value) => {
  //     setFarmerPartner(value);
  //     setErrors({ ...errors, project: "" });
  //   };

  // const onStartDateChange = (newValue) => {
  //   var formattedDate = dayjs(newValue).format("YYYY-MM-DD");
  //   setFormattedStartDate(formattedDate);
  //   setStartDate(newValue);
  //   setEndDate(newValue);
  // };
  // const onEndDateChange = (newValue) => {
  //   var formattedDate = dayjs(newValue).format("YYYY-MM-DD");
  //   setFormattedEndDate(formattedDate);
  //   setEndDate(newValue);
  // };

  const fetchData = async (params) => {
    try {
      const response = await getProjectData(params);
      if (
        response != null &&
        response != undefined &&
        response.data !== null &&
        response.data !== undefined &&
        response.data.results !== null &&
        response.data.results !== undefined
      ) {
        setProjectList(response.data.results);
      } else {
        //   setAddFormSnackBarType("error");
        // setAddFormSnackBar(true);
        // setAddFormSnackBarMessage("Something went wrong on sever!")
        setOpenSuccessBox(true);
        setSuccessMessage("Something went wrong on sever!");
        setOpenSuccessBoxType("error");
      }
    } catch (error) {
      // setAddFormSnackBarType("error");
      // setAddFormSnackBar(true);
      // setAddFormSnackBarMessage("Not able to fetch projects, Please check server!");
      console.error(error);
      setOpenSuccessBox(true);
      setSuccessMessage("Not able to fetch projects, Please check server!");
      setOpenSuccessBoxType("error");
    } finally {
      return () => {};
    }
  };
  useEffect(() => {
    if (projectList[0].id === "") {
      const params = { limit: 1000 };

      fetchData(params);
    }
  }, []);

  const handleChangeProjects = (value) => {
    setProjects(value);
    setErrors({ ...errors, datasetName: "" });
  };
  //   useEffect(async () => {
  //     try {
  //       const response = await getFromData({ fields: ["id", "name"] });
  //       setFormIdList(response.data["data"]);
  //     } catch {
  //       setSnackBarType("error");
  //       setAddPartnerSnackBar(true);
  //       setAddPartnerSnackBarMessage("Error while getting form list"); // Use error.response.data here
  //     }
  //   }, []);

  const handleCloseByClearIcon = () => {
    setErrors(basicError);
    setDatasetName("");
    // setProjectStatus("");
    // setFormIds([]);
    setAddPartnerSnackBar(false);
    setSnackBarType("success");
    setAddPartnerSnackBarMessage("");
    setProjectSnackBarType("");
    setProjectSnackBarMessage("");
    handleClose();
  };

  const handleSaveData = async () => {
    if (
      errors.datasetName === "" &&
      errors.project === "" &&
      datasetName !== ""
      // project !== null
    ) {
      //   const userIdArray = project.map((user) => user.id);
      //   const data = {
      //     name: datasetName,
      //     users: userIdArray,
      //     // ...(userIdArray.length > 0 && { users: userIdArray })
      //   };

      const payload = {
        name: datasetName,
        schema: JSON.stringify(schema),
        upload_type: "django",
        project: projects.id,
      };
      try {
        setLoading(true);
        const response = await postFormData(payload);
        setReload(true);
        setLoading(false);
        handleClose();
        setSuccessMessage("Form created successfully!");
        setOpenSuccessBoxType("success");
        setOpenSuccessBox(true);
      } catch (error) {
        if (error.response && error.response.data) {
          if (error.response.data.name) {
            setSuccessMessage(error.response.data.name);
          } else if (error.response.data.users) {
            setSuccessMessage(error.response.data.users);
          } else {
            setSuccessMessage("An unknown error occurred.");
          }
        } else {
          setSuccessMessage("An unknown error occurred."); // or provide a default message
        }
        setLoading(false);
        setOpenSuccessBox(true);
        setOpenSuccessBoxType("error");
      }
    } else {
      validateProjectFormData();
      setOpenSuccessBox(true);
      setSuccessMessage("Please fill all the required fields");
      setOpenSuccessBoxType("error");
    }
  };

  const getPartnerList = async () => {
    setLoading(true);
    try {
      const response = await getPartnerData({ all: "true" });
      setPartnerDataResponse(response.data);
      const partnerNamesList = response.data.map((item) => ({
        id: item.id,
        name: item.user.username,
      }));
      setPartnerNamesData(partnerNamesList);
      setLoading(false);
    } catch (error) {
      setSnackBarType("error");
      setAddPartnerSnackBar(true);
      setAddPartnerSnackBarMessage("Error while getting user list");
    }
  };

  return (
    <Modal open={openAddModal}>
      <Grid container sx={subGridStyle} spacing={1}>
        <ThemeProvider theme={basicTheme}>
          <Grid item xs={11} marginY={1.5}>
            <Typography
              variant="h4"
              sx={{ color: "#444444", fontWeight: "500" }}
            >
              Publish Form
            </Typography>
          </Grid>
          <Grid
            item
            xs={1}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CloseRoundedIcon
              // className={classes.closeBtnStyle}
              onClick={handleCloseByClearIcon}
            />
          </Grid>
          <Grid container item spacing={2} xs={12} sx={{ width: "90%" }}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Dataset Name
              </Typography>
              <BasicTextfield
                label="Enter Dataset Name"
                is_phone={false}
                handleChange={handleChangeProjectName}
                is_disabled={false}
                index={1}
                error={errors.datasetName !== ""}
                helperText={errors.datasetName}
                required={true}
                value={datasetName}
                // allowWhiteSpace={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Projects</Typography>
              <AutoCompleteDropdown
                width={230}
                menuList={projectList}
                // value={projects}
                selectedOptions={projects}
                onHighlightChange={(value) => {
                  handleChangeProjects(value);
                }}
                label="Select Projects"
                // error={false}
                required={true}
                error={errors.datasetName !== ""}
                errorText={errors.datasetName}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Project Status
              </Typography>
              <BasicDropDown
                text="Select Project Status"
                value={projectStatus}
                handleChange={handleChangeProjectStatus}
                menuList={projectStatusList}
                error={errors.projectStatus !== ""}
                required={true}
                errorText={errors.projectStatus}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Project Start Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="DD/MM/YYYY"
                  value={startDate}
                  minDate={dayjs()}
                  onChange={onStartDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onKeyDown={(e) => e.preventDefault()}
                      sx={{
                        marginBottom: 1,
                        borderRadius: "1rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius of the outline
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius on hover
                        },
                        width: "90%",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Project End Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate}
                  onChange={onEndDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onKeyDown={(e) => e.preventDefault()}
                      sx={{
                        marginBottom: 1,
                        borderRadius: "1rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius of the outline
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius on hover
                        },
                        width: "90%",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Forms</Typography>
              <AutoCompleteMultiDropdown
                width={230}
                menuList={formIdList}
                selectedOptions={formIds}
                onHighlightChange={(value) => { handleChangeProjectFrom(value) }}
                label="Select Forms"
                // disable={disable || getForms.length === 0}
                required={true}
                error={errors.projectForms !== ""}
                errorText={errors.projectForms}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  marginBottom: 1,
                }}
              >
                Users
              </Typography>
              <AutoCompleteMultiDropdown
                width="auto"
                menuList={partnerNamesData}
                selectedOptions={project}
                setSelectedOptions={handleChangeFarmerPartner}
                label="Select User(s)"
                required={true}
                onOpen={getPartnerList}
                loading={loading}
                error={errors.project !== ""}
                errorText={errors.project}
              />
            </Grid> */}
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              item
              sm={12}
              spacing={0}
              sx={{
                direction: "row",
                justifyContent: "center",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <Grid
                item
                xs={12}
                sm={2.5}
                style={{ backgroundColor: "transparent", boxShadow: "none" }}
              >
                <ButtonStyle
                  variant="contained"
                  name="cancel"
                  onClick={handleClose}
                >
                  Cancel
                </ButtonStyle>
              </Grid>
              <Grid item xs={12} sm={2.5}>
                <ButtonStyle
                  variant="contained"
                  name="add"
                  startIcon={<CheckIcon size="large" />}
                  onClick={handleSaveData}
                >
                  Save
                </ButtonStyle>
              </Grid>
            </Grid>
            <div style={{ willChange: "transform" }}>
              {addPartnerSnackBar && (
                <SnackBars
                  open={addPartnerSnackBar}
                  handleClose={() => setAddPartnerSnackBar(false)}
                  severity={snackBarType}
                  message={addPartnerSnackBarMessage}
                  autoHideDuration={6000}
                  vertical="bottom"
                  horizontal="center"
                />
              )}
            </div>
          </Grid>
          <BackDropLoader loading={loading} />
          <BackDropLoader loading={isLoading} />
        </ThemeProvider>
      </Grid>
    </Modal>
  );
}
